<!---- 
  -- This is the default layout for all marketing (i.e., non-app) pages.
  -- It sets up:
  --  * Navbar/header/footer
  --
  -- It inherits from /routes/__layout-base.svelte, which sets up analytics
  -- and error/exception tracking.
  ---->
<script lang="ts">
  import { setHighContrastIfNotManuallySet } from '$lib/stores/highContrastTheme.store';
  import { onMount } from 'svelte';

  import Footer from '$lib/teach/Footer.svelte';
  import { highContrastStore } from '$lib/stores/highContrastTheme.store';

  onMount(() => {
    setHighContrastIfNotManuallySet(!!window.matchMedia('(prefers-contrast: more)').matches);
  });

  let highContrast = false;
  highContrastStore.subscribe((bool) => {
    highContrast = bool;
  });
</script>

<div class:high-contrast={highContrast}>
  <div style="position: relative">
    <div class="bg-blue wrapper py-4">
      <header class="">
        <!-- Navigation: Big Screens -->
        <div class="margins md:flex justify-between hidden">
          <div class="flex-initial mt-2">
            <a href="/"
              ><img
                class="inline-block h-10"
                src="/teach/t-landing/logo-utheory-navigation-green.svg"
                alt="uTheory Logo"
                aria-hidden="true"
              /><span class="sr-only">uTheory Homepage</span></a
            >
          </div>
          <div id="nav" class="text-right relative" style="padding-top: 10px">
            <a
              rel="external"
              href="https://info.utheory.com"
              class="text-white font-semibold underline mt-3 pr-3 mr-2 lg:mr-10">Read the Blog ></a
            >
            <a href="/" class="text-white font-semibold underline mt-3 pr-3 mr-2 lg:mr-10"
              >uTheory Homepage ></a
            >
          </div>
        </div>
        <!-- /Navigation: Big Screens -->

        <!-- /Navigation: Small Screens -->
        <div class="margins block md:hidden">
          <div id="nav" class="flex justify-between relative">
            <a
              rel="external"
              href="https://info.utheory.com/"
              class="text-white font-semibold underline text-xs xs:text-base py-4"
              >Read the Blog ></a
            >
            <a
              rel="external"
              href="https://info.utheory.com/about"
              class="text-white font-semibold underline text-xs xs:text-base py-4"
              >uTheory Homepage ></a
            >
          </div>
          <hr class="mt-3 mb-5" />
          <div class="margins flex">
            <div class="flex-initial">
              <a href="/"
                ><img
                  class="inline-block w-24"
                  src="/teach/t-landing/logo-utheory-navigation-green.svg"
                  alt="uTheory Logo"
                  aria-hidden="true"
                /></a
              >
            </div>
          </div>
        </div>
      </header>
      <!-- /Navigation: Small Screens -->
    </div>
  </div>
</div>
<div class="wrapper mt-2 mb-8">
  <div class="margins page-content">
    <slot />
  </div>
</div>
<Footer />
